import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-print-modal',
  templateUrl: './print-modal.component.html',
  styleUrls: ['./print-modal.component.scss']
})
export class PrintModalComponent implements OnInit, OnDestroy {
  @Input() title = 'modal title';
  @Input() size = '';
  @Input() modalId = '';
  @Output() onModalClosed = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
    setTimeout(() => {
      document.querySelector(`#${this.modalId}`).addEventListener('bs.modal.show', () => {
        this.onModalShow();
      });
      document.querySelector(`#${this.modalId}`).addEventListener('bs.modal.hidden', () => {
        this.onModalHide();
      });
    }, 0);
  }

  ngOnDestroy(): void {
    document.querySelector(`#${this.modalId}`).removeEventListener('bs.modal.show', () => {
      this.onModalShow();
    });
    document.querySelector(`#${this.modalId}`).removeEventListener('bs.modal.hidden', () => {
      this.onModalHide();
    });
  }

  onModalShow() {
  }

  onModalHide() {
    this.onModalClosed.emit(true);
  }
}
